import { render, staticRenderFns } from "./BaseDirListPopupWrappable.vue?vue&type=template&id=4d53a13a&scoped=true&lang=pug&"
import script from "./BaseDirListPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./BaseDirListPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./BaseDirListPopupWrappable.vue?vue&type=style&index=0&id=4d53a13a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d53a13a",
  null
  
)

export default component.exports